/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import Vue from 'vue'
import Vuex from 'vuex' 
import system from './modules/system'
import site from './modules/site'
import auth from './modules/auth'
import autoQA from './modules/autoQA'
import VuexPersistence from 'vuex-persist'
import WyConstants from '../library/wy-constants.js';

Vue.use(Vuex)

const vuexSession = new VuexPersistence({
  storage: window.sessionStorage,
  key: WyConstants.SESSION_SITE_KEY_AQ,
  reducer: (state) => ({ site: state.site }),

  // restoreState: (key, storage) => {
  //   return JSON.parse(storage.getItem(key));
  // },
  // saveState: (key, state, storage) => {
  //   console.log('saveState', key, state, storage)
  //   storage.setItem(key, JSON.stringify(state));
  // },
})

export default new Vuex.Store({
  modules: {
    system,
    site,
    auth,
    autoQA,
  },
  plugins: [vuexSession.plugin]
})
